import { Utils } from "common/utils";
import React from "react";

interface Props {
  emailAddresses: string
  emailBlacklisted: boolean
}

const ContactEmailRow = (props: Props) => {
  const emails = Utils.splitEmails(props.emailAddresses);

  return <div className="flex-column gap-small">
    {emails.map((e, idx) =>
      <div key={`${e}-${idx}`}>
        <div><a href={`mailto:${e}`}>{e}</a></div>
      </div>)}
    {props.emailBlacklisted && <div className="text-sublabel">{RESX.Company.EmailIsBlacklisted}</div>}
  </div>;
};

export default ContactEmailRow;